/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The algos either buy or sell, depending on if asset's in a given strategy are overweight/underweight.
 * @export
 */
export const AlgoAction = {
    BUY: 'buy',
    SELL: 'sell'
} as const;
export type AlgoAction = typeof AlgoAction[keyof typeof AlgoAction];


export function instanceOfAlgoAction(value: any): boolean {
    for (const key in AlgoAction) {
        if (Object.prototype.hasOwnProperty.call(AlgoAction, key)) {
            if (AlgoAction[key as keyof typeof AlgoAction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function AlgoActionFromJSON(json: any): AlgoAction {
    return AlgoActionFromJSONTyped(json, false);
}

export function AlgoActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlgoAction {
    return json as AlgoAction;
}

export function AlgoActionToJSON(value?: AlgoAction | null): any {
    return value as any;
}

export function AlgoActionToJSONTyped(value: any, ignoreDiscriminator: boolean): AlgoAction {
    return value as AlgoAction;
}

